import OrderData from 'components/gruenland/molecules/order/OrderData';
import { useFormat } from 'helpers/hooks/useFormat';
import { Order } from 'types/entity/order';

interface Props {
  order: Order;
}

const OrderDetails: React.FC<Props> = ({ order }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <>
      <OrderData
        label={formatMessage({
          id: 'order.number',
          defaultMessage: 'Numero ordine',
        })}
      >
        {order.orderNumber}
      </OrderData>
      <OrderData
        label={formatMessage({
          id: 'order.orderState',
          defaultMessage: 'Stato ordine',
        })}
        className="mt-2"
      >
        {order.orderState}
      </OrderData>
      <OrderData
        label={formatMessage({
          id: 'order.shipmentState',
          defaultMessage: 'Stato spedizione',
        })}
        className="mt-2"
      >
        {order.shipmentState}
      </OrderData>
    </>
  );
};

export default OrderDetails;
